import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { Machine } from '../../core/models/entities/machine.type';
import { BehaviorScreen } from '../../core/models/view-models/monitor-models/screen.type';
import { MonitorFilterPipe } from '../../core/pipes/monitor-filter.pipe';
import { ViewMode } from '../../core/enums/view-mode.enum';
import { generateSwiperConfigurationHelper } from '../../core/helpers/generate-swiper-config.helper';
import { MonitorChangeViewService } from '../../core/services/http-services/monitor-change-view.service';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';

@Component({
  selector: 'item-view-full-screen',
  templateUrl: './item-view-full-screen.component.html',
  styleUrls: ['./item-view-full-screen.component.scss']
})
export class ItemViewFullScreenComponent implements OnChanges, OnDestroy {

  @Input() locations: Machine[] = [];
  @Input() monitorFilter: string;
  @Input() screens: BehaviorScreen[] = [];
  @Input() viewMode: ViewMode;

  public monitors: BehaviorScreen[] = [];
  public swiperConfig = generateSwiperConfigurationHelper(10, 2000, false, true, false);

  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly monitorFilterPipe: MonitorFilterPipe,
    public readonly monitorChangeViewService: MonitorChangeViewService,
    private readonly screenStateService: ScreensStateService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.locations || changes.monitorFilter || changes.screens)) {
      this.initMonitors();
    }
  }

  ngOnDestroy(): void {
    this.monitorChangeViewService.initChangeImageModel(this.monitorChangeViewService.fullScreenMonitor);
    this.monitorChangeViewService.fullScreenMonitor = null;
    this.subscriptions.unsubscribe();
  }

  getListOfMonitorsToSelect(): BehaviorScreen[] {
    if (this.monitorChangeViewService && this.monitorChangeViewService.fullScreenMonitor) {
      return this.screenStateService.getRestMonitorsExceptFullScreen(this.monitors, this.monitorChangeViewService.fullScreenMonitor);
    }

    return this.monitors;
  }

  private initMonitors(): void {
    const selectedLocation: Machine = this.locations.find((location) => location.IsSelected);
    this.monitors = this.monitorFilterPipe.transform(
      this.screens,
      selectedLocation,
      this.monitorFilter
    ) as BehaviorScreen[];

    this.subscriptions.add(
      this.monitorChangeViewService.selectedForFullScreenChanged.subscribe((selectedScreen: BehaviorScreen) => {
        if (selectedScreen && !this.isFullScreenMonitorShouldChangedPredicate(selectedScreen)) {
          this.monitorChangeViewService.initChangeImageModel(selectedScreen, true);
        }
      })
    );

    if (this.monitorChangeViewService.fullScreenMonitor) {
      const isFullScreenMonitorShouldChange: boolean = !_.some(this.monitors, (monitor: BehaviorScreen) =>
        this.isFullScreenMonitorShouldChangedPredicate(monitor));

      if (isFullScreenMonitorShouldChange) {
        this.monitorChangeViewService.selectedForFullScreenChanged.next(this.monitors[0]);
      }
    }
  }

  private isFullScreenMonitorShouldChangedPredicate(monitor: BehaviorScreen): boolean {
    return this.monitorChangeViewService.fullScreenMonitor &&
      this.monitorChangeViewService.fullScreenMonitor.MonitorHandler === monitor.MonitorHandler &&
      this.monitorChangeViewService.fullScreenMonitor.MachinePhysicalAddress === monitor.MachinePhysicalAddress;
  }
}
